import { render, staticRenderFns } from "./populateAutomaticTagsPopup.vue?vue&type=template&id=addf3f8e"
import script from "./populateAutomaticTagsPopup.vue?vue&type=script&lang=js"
export * from "./populateAutomaticTagsPopup.vue?vue&type=script&lang=js"
import style0 from "./populateAutomaticTagsPopup.vue?vue&type=style&index=0&id=addf3f8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports